(() => {
  const root = document.documentElement;
  const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  root.classList.add('tp-js');

  const updateHeaderState = () => {
    document.body.classList.toggle('tp-scrolled', window.scrollY > 12);
  };

  updateHeaderState();
  window.addEventListener('scroll', updateHeaderState, { passive: true });

  if (!reduceMotion && 'IntersectionObserver' in window) {
    const targets = document.querySelectorAll(
      '.content-for-layout .shopify-section, .card-wrapper, .tp-dossier__panel'
    );

    const reveal = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            entry.target.classList.add('tp-in-view');
            reveal.unobserve(entry.target);
          }
        });
      },
      { rootMargin: '0px 0px -10% 0px', threshold: 0.08 }
    );

    targets.forEach((target) => {
      target.classList.add('tp-watch');
      reveal.observe(target);
    });
  }

  const finePointer = window.matchMedia('(hover: hover) and (pointer: fine)').matches;

  if (!reduceMotion && finePointer) {
    document.querySelectorAll('.card-wrapper').forEach((card) => {
      card.addEventListener('pointermove', (event) => {
        const rect = card.getBoundingClientRect();
        const x = (event.clientX - rect.left) / rect.width - 0.5;
        const y = (event.clientY - rect.top) / rect.height - 0.5;
        card.style.setProperty('--tp-card-x', (x * 3).toFixed(2));
        card.style.setProperty('--tp-card-y', (y * 3).toFixed(2));
      });

      card.addEventListener('pointerleave', () => {
        card.style.setProperty('--tp-card-x', '0');
        card.style.setProperty('--tp-card-y', '0');
      });
    });
  }
})();
